<template>
    <div v-if="lots">
        <div class="auction__items" v-infinite-scroll="load" infinite-scroll-disabled="loading">
            <a :href="lot.url" class="auction__item" v-for="lot in lots">
                <div class="auction__tags">
                    <span class="auction__tag" v-for="category in lot.lot_categories">{{ category.title }}</span>
                    <span class="auction__tag">{{ lot.office.city.title }}</span>
                </div>
                <div class="auction__card">
                    <div class="auction__name">
                        <span class="auction__number">ЛОТ {{ lot.id }}: </span>{{ lot.title }}
                    </div>
                    <div class="auction__img" :style="'background-image: url('+ (lot.main_image ? lot.main_image.url : lot.photos[0].url) + ');' " />
                    <div class="auction__info">
                       <!-- <div class="auction__info-item" v-if="!lot.deleted_at">
                            <span class="auction__info-name">Текущая цена</span>
                            <span class="auction__price">{{ lot.last_price ? Number(lot.last_price).toLocaleString('ru') : Number(lot.original_price).toLocaleString('ru') }} ₽</span>
                        </div>-->
                        <div class="auction__info-item" v-if="lot.deleted_at && lot.last_price > 0">
                            <span class="auction__info-name">Выигрышная ставка</span>
                            <span class="auction__price">{{ Number(lot.last_price).toLocaleString('ru')}} ₽</span>
                        </div>
                        <div class="auction__info-item" v-if="!lot.deleted_at">
                            <span class="auction__info-name" v-if="checkBeforeNowDate(lot.start_auction)">Идут торги</span>
                            <span class="auction__info-name" v-else>Ожидает торгов</span>
                            <span class="auction__price" style="visibility: hidden;">{{ Number(lot.original_price).toLocaleString('ru')}}</span>
                           <!-- <span class="auction__info-name" v-if="checkBeforeNowDate(lot.start_auction)">До конца торгов</span>
                            <span class="auction__info-name" v-else>До начала торгов</span>
                            <countdown class="auction__time" :time="lot.countdown" :transform="transform">
                                <template slot-scope="props">
                                    <template v-if="props.days !== '00'">
                                        <span class="auction__time-item">{{ props.days }}</span>д
                                    </template>
                                    <span class="auction__time-item">{{ props.hours }}</span> :
                                    <span class="auction__time-item">{{ props.minutes }}</span>
                                    <template v-if="props.days === '00'">
                                        : <span class="auction__time-item">{{ props.seconds }}</span>
                                    </template>
                                </template>
                            </countdown>-->
                        </div>
                        <div class="auction__info-item" v-else>
                            <span class="auction__info-name">Торги завершены</span>
                            <span class="auction__price" style="visibility: hidden;">{{ Number(lot.original_price).toLocaleString('ru')}}</span>
                        </div>
                    </div>
                </div>
            </a>
        </div>
        <div v-if="loading" class="auction__loading-box">
            <i class="auction__loading el-icon-loading"></i>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import {store} from "../../../store/lot";
    import style from "../../../mixins/style";

    export default {
        name: "LotCards",
        store,
        mixins: [style],
        data: () => ({
            count: 8,
            loading: false,
            data: [],
        }),
        computed: {
            ...mapState([
                'lots',
                'filter'
            ]),
        },
        methods: {
            ...mapActions([
                'getLots'
            ]),
            load() {
                if (this.count < this.data.length) {
                    this.loading = true
                    setTimeout(() => {
                        this.count += 16
                        this.loading = false
                    }, 2000)
                }
            }
        },
        mounted() {
            this.getLots();

            for (let i = 0; i < 16; i++) {
                this.data.push(this.dataSample);
            }
        }
    }
</script>
